export enum DeliveryMethod {
  Onsite = 'onsite',
  Offsite = 'offsite',
}
